<template>
  <div id="app">
    <NavBar v-if="!('embed' in this.$route.query)" />
    <CampaignBar v-if="!('embed' in this.$route.query)"  />
    <MainWindow />
    <b-modal id="modal-inactivity" title="Automatic data update paused" header-bg-variant="info" hide-footer
             centered hide-header-close ok-only v-model="isInactive">
      <p>
        Automatic data update was paused after 15 minutes of inactivity. To resume, please move your mouse, click or press any key.
      </p>
    </b-modal>
  </div>
</template>

<script>
import BelugaClient from './mixins/beluga_client'
import NavBar from './components/bars/NavBar.vue'
import CampaignBar from './components/bars/CampaignBar.vue'
import MainWindow from './components/MainWindow.vue'
import StaClient from './mixins/sta_client'

export default {
  name: 'App',
  mixins: [
    BelugaClient,
    StaClient
  ],
  components: {
    NavBar,
    CampaignBar,
    MainWindow
  },
  computed: {
    isInactive: function () {
      if ('idleVue' in this.$store.state && !this.live_mode) {
        return this.$store.state.idleVue.isIdle
      }
      return false
    }
  }
}
</script>

<style>
</style>
